var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.608 47.3298C37.8305 45.8647 44.6218 44.6524 44.6998 44.6357L44.8416 44.6054L37.0788 35.2919C32.8092 30.1696 29.3159 25.9586 29.3159 25.9344C29.3159 25.8884 37.3317 3.62395 37.3768 3.54468C37.3919 3.51825 42.8469 13.0175 50.6001 26.5716C57.8588 39.2611 63.8432 49.7237 63.8989 49.8217L64 50L39.329 49.9968L14.658 49.9936L29.608 47.3298ZM0 44.4897C0 44.4766 3.65782 38.072 8.1285 30.2574L16.257 16.0489L25.7298 8.03061C30.9399 3.62056 35.2167 0.00694299 35.2338 0.000171477C35.251 -0.00623643 35.1824 0.167752 35.0815 0.386997C34.9806 0.606242 30.3518 10.6202 24.7954 22.6403L14.6927 44.4949L7.34634 44.5042C3.30586 44.5093 0 44.5028 0 44.4897Z",
    fill: "#0089D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.d4ccb849759215722c1e354505ad528f.svg";
export { ForwardRef as ReactComponent };